import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, LinearProgress, Checkbox } from "@material-ui/core";
import * as _ from "lodash";

import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import { Link, useHistory } from "react-router-dom";
import AppTable from "../Table/AppTable";
import TablePaginationActions from "../Table/TablePaginationActions";
import AppUtil from "../../../../utilities/AppUtil";
import AppButton from "../../../../components/CustomButtons/AppButton";
import AppColor from "../../../../utilities/AppColor";
import InputSearch from "../../../../components/Input/InputSearch";
import AppConfirmDialog from "../../../../components/Dialog/AppConfirmDialog";
// import AppConfig from "../../../../config/AppConfig";
import { makeStyles } from "@material-ui/core";
import moment from "moment";
import { fetchListPagingSubscription } from "store/slices/subscription";
import { getSubscriptionPage } from "store/slices/subscription";
import { reduceDeleteSubscriptionPlan } from "store/slices/subscription";
// import AppSelect from 'components/Select/AppSelect';

const headCells = [
  {
    id: "packageName",
    numeric: "left",
    disablePadding: false,
    label: "label.subscription_name",
    sort: true,
  },
  {
    id: "recurring",
    numeric: "left",
    disablePadding: false,
    label: "label.recurring",
    sort: true,
  },
  {
    id: "numberWorker",
    numeric: "left",
    disablePadding: false,
    label: "label.number_staff",
    sort: true,
  },
  {
    id: "numberClient",
    numeric: "left",
    disablePadding: false,
    label: "label.number_participant",
    sort: true,
  },
  {
    id: "pricing",
    numeric: "left",
    disablePadding: false,
    label: "label.price",
    sort: true,
  },
  {
    id: "createdDate",
    numeric: "left",
    disablePadding: false,
    label: "label.created_date",
    sort: false,
  },
  {
    id: "actions",
    numeric: "center",
    disablePadding: false,
    label: "label.actions",
    sort: false,
  },
];

const styles = makeStyles(() => ({
    shortText: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap",
      maxWidth: '376px'
  }
}));

const SubscriptionPlanTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = styles();

  const [queries, setQueries] = useState({
    asc_sort: true,
    page: 1,
    size: 10,
    search_key: "",
    sort_field: ""
  });
  const subscriptionList = useSelector(getSubscriptionPage);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [searchKey, setSearchKey] = useState("");

  const emptyRows = data.length === 0;

  const _handleDeleteSubscriptionPlan = async () => {
    if (selected.length > 0) {
      const selectedFilter = selected.filter(id => {
        if (typeof id !== 'boolean') {
          return id;
        }
      });
      await dispatch(reduceDeleteSubscriptionPlan({ ids: selectedFilter }));
      setShowDeleteModal(false);
      if((data.length === 1 || selectedFilter.length === data.length) && queries.page > 1) {
        _loadData({ ...queries, page: queries.page - 1 });
      } else {
        if (searchKey) {
          _loadData({ ...queries, search_key: searchKey });
        } else {
          _loadData();
        }
      }
    }
    // const params = {
    //   ids: selected,
    // };
    // await dispatch(fetchDeleteCompany(params));
    // setShowDeleteModal(false);
    // _loadData({ ...queries });

    setSelected([]);
  };

  const _handleSelect = (id) => {
    if (!selected.includes(id)) {
      setSelected([...selected, id]);
    } else {
      setSelected(selected.filter((item) => item !== id));
    }
  };

  const _handleSelectAll = () => {
    const dataCheck = _.union(dataCheck, data.map(item => !item.freePackage && item.id));
    if (dataCheck.length === selected.length ) {
      setSelected([]);
    } else {
      setSelected(_.union(selected, data.map(item => !item.freePackage && item.id)));
    }
    // if (data.length === selected.length) {
    //   setSelected([]);
    // } else {
    //   setSelected(
    //     _.union(
    //       selected,
    //       data.map((item) => !item.freePackage && item.id)
    //     )
    //   );
    // }
  };

  const handleChangePage = (event, newPage) => {
    _loadData({ ...queries, page: newPage + 1 });
    AppUtil.scrollToTopById("main-panel");
  };

  const handleChangeRowsPerPage = (event) => {
    _loadData({
      ...queries,
      page: 1,
      size: parseInt(event.target.value),
    });
    AppUtil.scrollToTopById("main-panel");
  };

  const onRequestSort = (event, property) => {
    _loadData({
      ...queries,
      sort_field: property === 'packageName' ? 'name'
      : property,
      asc_sort:
        (property === 'packageName' || property === queries.sort_field) ? queries.asc_sort !== true : true,
    });
  };

  const onSearch = (value) => {
    setSearchKey(value);
    _loadData({
      ...queries,
      search_key: value,
      page: 1,
    });
  };

  const _loadData = async ({
    page,
    size,
    search_key,
    asc_sort,
    sort_field,
    approval_status
  } = {}) => {
    const newQueries = {
      ...queries,
    };
    if (page) {
      newQueries.page = page;
    }
    if (size) {
      newQueries.size = size;
    }
    if (sort_field) {
      newQueries.sort_field = sort_field;
    }
    newQueries.approval_status = approval_status || "";
    newQueries.search_key = search_key || "";
    newQueries.asc_sort = !(!asc_sort || false);
    setLoading(true);
    dispatch(fetchListPagingSubscription(newQueries)).then(({ payload }) => {
      setQueries(newQueries);
      setLoading(false);
      if (payload) {
        setTotalElements(payload.totalElements);
      }
    });
  };

  useEffect(() => {
    _loadData();
  }, []);

  useEffect(() => {
    if (subscriptionList) setData(subscriptionList);
  }, [subscriptionList]);

  const handleCreateSubscriptionPlan = () => {
    history.push(`/admin/subscription-plan/create`);
  };

  return (
    <div>
      <div>
        <AppButton
          label={t("button.new_subscription_plan")}
          onClick={() => handleCreateSubscriptionPlan()}
          style={{
            marginRight: "1rem",
          }}
        />
        <AppButton
          label={t("button.delete")}
          buttonColor={AppColor.pink}
          onClick={() => setShowDeleteModal(true)}
          disabled={selected.length === 0}
        />
      </div>
      <Box my={3}>
        <InputSearch onSearch={onSearch} searchText={searchKey} />
      </Box>
      <AppTable
        onRequestSort={onRequestSort}
        order={queries.asc_sort === true ? "asc" : "desc"}
        orderBy={queries.sort_field === 'name' ? 'packageName' : queries.sort_field}
        rowCount={data.length}
        headCells={headCells}
        numSelected={selected.length}
        onSelectAllClick={_handleSelectAll}
      >
        <TableBody>
          {loading && (
            <TableRow>
              <TableCell colSpan={7} padding="none">
                <LinearProgress />
              </TableCell>
            </TableRow>
          )}
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell padding="checkbox">
                {!row.freePackage && 
                  <Checkbox
                  checked={selected.indexOf(row.id) !== -1}
                  inputProps={{ "aria-labelledby": row.id }}
                  onClick={() => _handleSelect(row.id)}
                  color="primary"/>
                }
              </TableCell>
              <TableCell>{row.packageName && row.packageName.length > 32 ?
                <p className={classes.shortText}>{row.packageName}</p>
              : <span>{row.packageName}</span>}</TableCell>
              <TableCell>{row.recurring === 'MONTH' ? t('label.month') : t('label.year')}</TableCell>
              <TableCell>{row.numberWorker}</TableCell>
              <TableCell>{row.numberClient}</TableCell>
              <TableCell align="left">{`$${row.pricing}`}</TableCell>
              <TableCell>{moment.utc(row.createdDate).local().format('yyyy/MM/DD HH:mm:ss').toString()}</TableCell>
              {!row.freePackage &&
              <TableCell>
              <Link
                to={`/admin/subscription-plan/${row.id}`}
                className="text-center"
              >
                <Button variant="text">
                  <i className="fas fa-edit" />
                </Button>
              </Link>
            </TableCell>}
            </TableRow>
          ))}

          {emptyRows > 0 && (
            <TableRow style={{ height: 53 }}>
              <TableCell colSpan={headCells.length + 1} className="text-center">
                {t("label.no_data")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              colSpan={headCells.length}
              count={totalElements}
              rowsPerPage={queries.size}
              page={queries.page - 1}
              SelectProps={{
                inputProps: { "aria-label": "rows per page" },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
              labelRowsPerPage={`${t("label.rows_per_page")}:`}
              labelDisplayedRows={({ from, to, count }) =>
                t("label.from_to", {
                  from,
                  to,
                  count: count !== -1 ? count : `${t("text.more_than")} ${to}`,
                })
              }
            />
          </TableRow>
        </TableFooter>
      </AppTable>
      <AppConfirmDialog
        open={showDeleteModal}
        onConfirm={() => _handleDeleteSubscriptionPlan()}
        onClose={() => setShowDeleteModal(false)}
        title={t("title.delete_company")}
        content={t("text.delete_company")}
      />
    </div>
  );
};

export default SubscriptionPlanTable;
